import { render } from "./Firefighter.vue?vue&type=template&id=0801d38f&scoped=true"
import script from "./Firefighter.vue?vue&type=script&lang=js"
export * from "./Firefighter.vue?vue&type=script&lang=js"

import "./Firefighter.vue?vue&type=style&index=0&id=0801d38f&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0801d38f"]])

export default __exports__